import { z } from "zod";
import { zTextarea } from "@remotion/zod-types";


export const schema = z.object({
  markdown: zTextarea(),
  // theme is a string enum defined in theme.tsx
  // theme: z.string(),
});
